import {
	PHARMACY_MANAGER_CREATE_FOLDER_REQUEST,
	PHARMACY_MANAGER_CREATE_FOLDER_SUCCESS,
	PHARMACY_MANAGER_CREATE_FOLDER_FAILURE,
} from "../../../constants";

const initialState = {
	data: null,
	loading: false,
	error: null,
};

const pharmacyManagerCreateFolder = (state = initialState, action) => {
	switch (action.type) {
		case PHARMACY_MANAGER_CREATE_FOLDER_REQUEST:
			return {
				...state,
				loading: true,
				data: null,
				error: null,
			};
		case PHARMACY_MANAGER_CREATE_FOLDER_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			};
		case PHARMACY_MANAGER_CREATE_FOLDER_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null,
			};
		default:
			return state;
	}
};

export default pharmacyManagerCreateFolder;
